import {
  Card,
  FormHelperText,
  Grid,
  InputLabel,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import InputField from "../../../../common/InputField";
import "./CareDirective.scss";
import {
  LinkButton,
  PrimaryButton,
  SecondaryButton,
} from "../../../../common/Buttons";
import {
  setCareDirectiveData,
  getCareDirectiveData,
} from "../../../../services/documentServices";
import styled from "@emotion/styled";
import { toast } from "react-hot-toast";
import { setStepStatus } from "../../../../utils/Utilities";
import { useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const StyledInput = styled(InputField)`
  & .MuiOutlinedInput-notchedOutline {
    border-color: #d8d8d8;
  }
`;

const FoodDrink = ({ next, setButtonDisabled }) => {
  const { t } = useTranslation();
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [initialValues, setInitialValues] = useState({
    foodLike: "",
    foodDislike: "",
    drinkLike: "",
    drinkDislike: "",
  });

  const validate = Yup.object({
    foodLike: Yup.string().nullable(),
    foodDislike: Yup.string().nullable(),
    drinkLike: Yup.string().nullable(),
    drinkDislike: Yup.string().nullable(),
  });

  const handleSubmit = async (values) => {
    setButtonDisabled(true);
    const { stepStatus, careDirectiveId, foodDrinkId, ...rest } = values;
    const payload = {
      ...data,
      foodDrink: {
        ...rest,
        careDirectiveId,
        foodDrinkId,
        stepStatus: setStepStatus("00-00-0000", { ...rest }),
      },
    };
    const result = await setCareDirectiveData(payload, id);
    if (result?.success) {
      next();
    }
    setButtonDisabled(false);
  };

  const getCareDirectiveDataFun = async () => {
    setButtonDisabled(true);
    const result = await getCareDirectiveData(id);
    if (result?.success && result?.payLoad) {
      setData(result.payLoad);
      if (result.payLoad.foodDrink !== null) {
        setInitialValues(result.payLoad.foodDrink);
      }
    }
    setButtonDisabled(false);
  };

  useEffect(() => {
    getCareDirectiveDataFun();
  }, []);

  return (
    <Card className="care-directive documents-card-height summary-table">
      <Grid container>
        <Grid item lg={7} md={6} sm={12} xs={12} className="outer outer-pt-10">
          <Typography
            className="paragraph"
            color="color.magentaDark2"
            sx={{ mb: 2 }}
          >
            You hereby specify how you would like to be cared for if you are no
            longer able to express yourself. In the event that I become in need
            of care, these wishes should please be respected by my authorized
            representative or my caregiver and the people who care for me:
          </Typography>
          <Formik
            initialValues={initialValues}
            enableReinitialize
            validationSchema={validate}
            onSubmit={(values) => handleSubmit(values)}
          >
            {(formik) => (
              <Form id="form_submit" onSubmit={formik.handleSubmit}>
                <InputLabel sx={{ mt: 2, color: "color.magentaDark2" }}>
                  {t("cd-tab-1")}
                </InputLabel>
                <FormHelperText sx={{ color: "color.magentaDark2" }}>
                  {t("cd-fd-eat")}
                </FormHelperText>
                <StyledInput
                  fullWidth
                  multiline
                  rows={3}
                  variant="outlined"
                  name="foodLike"
                  type="text"
                />
                <FormHelperText sx={{ mt: 2, color: "color.magentaDark2" }}>
                  {t("cd-fd-eat-no")}
                </FormHelperText>
                <StyledInput
                  fullWidth
                  multiline
                  rows={3}
                  variant="outlined"
                  name="foodDislike"
                  type="text"
                />
                <FormHelperText sx={{ mt: 2, color: "color.magentaDark2" }}>
                  {t("cd-fd-drink")}
                </FormHelperText>
                <StyledInput
                  fullWidth
                  multiline
                  rows={3}
                  variant="outlined"
                  name="drinkLike"
                  type="text"
                />
                <FormHelperText sx={{ mt: 2, color: "color.magentaDark2" }}>
                  {t("cd-fd-drink-no")}
                </FormHelperText>
                <StyledInput
                  fullWidth
                  multiline
                  rows={3}
                  variant="outlined"
                  name="drinkDislike"
                  type="text"
                />
              </Form>
            )}
          </Formik>
        </Grid>
      </Grid>
    </Card>
  );
};

export default FoodDrink;
